import { CodedResultError } from './coded-result.error';

/** HTTP 409; specific business behavior is selected by code. */
export class ConflictResultError<T = unknown> extends CodedResultError<T> {}
